import './MembershipsEmptyState.css';

import { Crown } from 'lucide-react';

type Props = {
  onCreateTier: () => void;
};

const NoTiersEmptyState = ({ onCreateTier }: Props) => (
  <section className="memberships-empty" data-testid="no-tiers-empty-state">
    <span className="memberships-empty__icon" aria-hidden="true">
      <Crown size={26} />
    </span>
    <h2 className="memberships-empty__title">No tiers yet</h2>
    <p className="memberships-empty__body">
      Start by creating your first membership tier. Pick a card theme, set the
      price and validity, and customers can be enrolled the moment it&apos;s
      published.
    </p>
    <button type="button" className="memberships-empty__cta" onClick={onCreateTier}>
      + Create your first tier
    </button>
  </section>
);

export default NoTiersEmptyState;
